module.exports = __webpack_public_path__ + "img/shopIcon7.3f2bfb57.png";